import React from 'react';
import PropTypes from 'prop-types';

import Svg, { G, Circle, Path, Defs, Rect } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function VascoFailIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (

    <Svg
      {...svgProps}
      viewBox="0 0 90 121">

      <Defs>
        <Path
          d="M72.3137085,22.3137085 L72.3137085,16.3145802 C72.3137085,15.761814 72.7575733,15.3137085 73.3137085,15.3137085 C73.8659932,15.3137085 74.3137085,15.7583394 74.3137085,16.3145802 L74.3137085,22.3137085 L80.3128368,22.3137085 C80.865603,22.3137085 81.3137085,22.7575733 81.3137085,23.3137085 C81.3137085,23.8659932 80.8690776,24.3137085 80.3128368,24.3137085 L74.3137085,24.3137085 L74.3137085,30.3128368 C74.3137085,30.865603 73.8698437,31.3137085 73.3137085,31.3137085 C72.7614237,31.3137085 72.3137085,30.8690776 72.3137085,30.3128368 L72.3137085,24.3137085 L66.3145802,24.3137085 C65.761814,24.3137085 65.3137085,23.8698437 65.3137085,23.3137085 C65.3137085,22.7614237 65.7583394,22.3137085 66.3145802,22.3137085 L72.3137085,22.3137085 Z"
          id="path-1"></Path>
      </Defs>
      <G stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
        <G transform="translate(-147.000000, -93.000000)">
          <G transform="translate(147.000000, 93.000000)">
            <Path
              d="M69.9132948,46.994685 L69.9132948,29.2734252 C69.9132948,13.1242126 56.8549133,0 40.7867052,0 C24.7184971,0 11.6601156,13.1242126 11.6601156,29.2734252 L11.6601156,46.994685 C5.09537572,47.9474409 0,53.6401575 0,60.5 L0,107.327953 C0,114.854724 6.09075145,121 13.6034682,121 L67.9699422,121 C75.4589595,121 81.5734104,114.878543 81.5734104,107.327953 L81.5734104,60.5 C81.5734104,53.6401575 76.5017341,47.9474409 69.9132948,46.994685 Z M15.5468208,29.2734252 C15.5468208,15.2917323 26.8751445,3.90629921 40.7867052,3.90629921 C54.6982659,3.90629921 66.0265896,15.2917323 66.0265896,29.2734252 L66.0265896,46.8279528 L15.5468208,46.8279528 L15.5468208,29.2734252 Z M77.6867052,107.327953 C77.6867052,112.711024 73.3260116,117.093701 67.9699422,117.093701 L13.6034682,117.093701 C8.24739884,117.093701 3.8867052,112.711024 3.8867052,107.327953 L3.8867052,60.5 C3.8867052,55.1169291 8.24739884,50.734252 13.6034682,50.734252 L67.9699422,50.734252 C73.3260116,50.734252 77.6867052,55.1169291 77.6867052,60.5 L77.6867052,107.327953 L77.6867052,107.327953 Z"
              fill={color}></Path>
            <Path
              d="M50.433526,78.765748 C50.433526,73.3826772 46.0728324,69 40.716763,69 C35.3606936,69 31,73.3826772 31,78.765748 C31,81.7431102 32.3271676,84.4822835 34.6260116,86.3401575 L32.6589595,100.250394 L48.7745665,100.250394 L46.8075145,86.3401575 C49.082659,84.5061024 50.433526,81.7669291 50.433526,78.765748 Z M42.6127168,84.4346457 L44.2953757,96.3440945 L37.1144509,96.3440945 L38.7971098,84.4346457 C38.7971098,84.4346457 34.8630058,82.4814961 34.8630058,78.765748 C34.8630058,75.526378 37.4699422,72.9062992 40.6930636,72.9062992 C43.916185,72.9062992 46.5231214,75.526378 46.5231214,78.765748 C46.5468208,82.505315 42.6127168,84.4346457 42.6127168,84.4346457 Z"
              id="Shape" fill={color}></Path>
            <Circle stroke="#FFFFFF" fill="#D0021B" cx="73" cy="23" r="16"></Circle>
            <G transform="translate(66.000000, 16.000000)" fill="#FFFFFF">
              {/* <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1"></use> */}
              <Rect id="Rectangle-2"
                    transform="translate(7.000000, 7.000000) rotate(-45.000000) translate(-7.000000, -7.000000) " x="6"
                    y="-1" width="2" height="16" rx="1"></Rect>
              <Rect id="Rectangle-2"
                    transform="translate(7.000000, 7.000000) rotate(45.000000) translate(-7.000000, -7.000000) " x="6"
                    y="-1" width="2" height="16" rx="1"></Rect>
            </G>
          </G>
        </G>
      </G>
    </Svg>
  );
}

VascoFailIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

VascoFailIcon.defaultProps = {
  height: 120,
  width: 120,
};

export default pure(VascoFailIcon);
